export enum AvailableLayoutTableStatus {
  OPEN = 'OPEN',
  RESERVED = 'RESERVED',
  CLOSED = 'CLOSED',
}
